import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';
import { ticketStatusList } from './constants';
import { getCityList } from '@/apis/commonApi';

const model = {
  state: {
    queryParams: {
      per_page: 20,
      cur_page: 1,
      type: '',
      status: '',
    },
    listLoading: false,
    tableList: [],
    listTotal: 0,
    detailVisible: false,
    detailStatus: {
      has_received: 0,
      has_checked: 0,
      has_deleted: 0,
    },
    detailList: [],
    detailListTotal: 0,
    detailListLoading: false,
    detailParams: {
      per_page: 20,
      cur_page: 1,
      detail_status: 'all',
    },
    shopData: [],
    shopDataFetching: false,
    selectedShop: null,
    subShopData: [],
    limitShopParams: {}, // 门店
    shopNames: [],
    cities: [], // 城市
    rangeData: [], // 商圈
    rangeTableData: [],
    cbd_ids: '', // 商圈id
    cbd_name: '', // 商圈名称
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { marketingPlatformCoupon }, getState }) => ({
    // 获取优惠券列表
    async getList() {
      const { union_shop_id, shop_id } = getState().basic;
      const { queryParams } = getState().marketingPlatformCoupon;
      const {
        platformCouponBatchId,
        platformCouponName,
        platformCouponShowName,
        cur_page,
        per_page,
        type,
        status,
      } = queryParams;
      marketingPlatformCoupon.setState({ listLoading: true });
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/list', {
        type: 'POST',
        useJson: true,
        params: filterNull({
          platformCouponBatchId,
          platformCouponName,
          platformCouponShowName,
          type,
          status,
          unionShopId: union_shop_id,
          shopId: shop_id,
          pageNum: cur_page,
          pageSize: per_page,
        }),
      });
      marketingPlatformCoupon.setState({ listLoading: false });
      if (data) {
        marketingPlatformCoupon.setState({
          tableList: data.records,
          listTotal: data.total,
        });
      }
    },
    // 搜索
    onSearch(queryParams) {
      marketingPlatformCoupon.setState({ queryParams });
      marketingPlatformCoupon.getList();
    },
    // 重置筛选项
    onReset() {
      marketingPlatformCoupon.setState({
        queryParams: {
          cur_page: 1,
          per_page: 20,
          type: '',
          status: '',
        },
      });
    },
    // 翻页
    onNav(page) {
      const { queryParams } = getState().marketingPlatformCoupon;
      marketingPlatformCoupon.setState({ queryParams: { ...queryParams, cur_page: page } });
      marketingPlatformCoupon.getList();
    },
    // 无效
    async onDisable(platformCouponBatchId) {
      const { union_shop_id, shop_id } = getState().basic;
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/invalid', {
        type: 'GET',
        params: { platformCouponBatchId, unionShopId: union_shop_id, shopId: shop_id },
      });
      if (data) {
        marketingPlatformCoupon.getList();
        message.success('失效平台券成功');
      }
    },
    // 获取详情列表
    async getDetailList(platformCouponBatchId) {
      const { union_shop_id, shop_id } = getState().basic;
      const { detailParams } = getState().marketingPlatformCoupon;
      marketingPlatformCoupon.setState({ detailListLoading: true });
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/detail', {
        type: 'GET',
        params: filterNull({
          type: ticketStatusList[detailParams.detail_status].key,
          platformCouponBatchId,
          unionShopId: union_shop_id,
          shopId: shop_id,
          pageNum: detailParams.cur_page,
          pageSize: detailParams.per_page,
        }),
      });
      if (data) {
        marketingPlatformCoupon.setState({
          detailList: data.list,
          detailListTotal: data.total,
          detailStatus: {
            has_received: data.receiveNum,
            has_checked: data.exchangeNum,
            has_deleted: data.invalidNum,
          },
        });
      }
      marketingPlatformCoupon.setState({ detailListLoading: false });
    },
    async exportDetail(detailId, setLogListDot) {
      const { union_shop_id, shop_id } = getState().basic;
      const { detailParams } = getState().marketingPlatformCoupon;
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/detail/export', {
        params: filterNull({
          type: ticketStatusList[detailParams.detail_status].key,
          platformCouponBatchId: detailId,
          unionShopId: union_shop_id,
          shopId: shop_id,
        }),
      });
      if (data) {
        message.success('导出成功');
        setLogListDot(true);
      }
    },
    setDetailVisible(visible) {
      marketingPlatformCoupon.setState({ detailVisible: visible });
    },
    // tabs
    onTabsChange(status) {
      const { detailParams } = getState().marketingPlatformCoupon;
      marketingPlatformCoupon.setState({
        detailParams: {
          ...detailParams,
          cur_page: 1,
          detail_status: status,
        },
      });
    },
    // 翻页
    onDetailNav(page) {
      const { detailParams } = getState().marketingPlatformCoupon;
      marketingPlatformCoupon.setState({ detailParams: { ...detailParams, cur_page: page } });
    },
    // 重置详情项
    onDetailReset() {
      marketingPlatformCoupon.setState({
        detailParams: {
          per_page: 20,
          cur_page: 1,
          detail_status: 'all',
        },
      });
    },
    formatShopLimit(shopLimit) {
      const shopLimitArr = [];
      Object.keys(shopLimit).forEach((key) => {
        const obj = {
          shop_id: Number(key),
          sub_shop_ids: shopLimit[key],
        };
        shopLimitArr.push(obj);
      });
      return shopLimitArr;
    },
    formatParams(params) {
      const {
        platformCouponBatchId,
        allLimit,
        amount,
        cbdIds,
        cbdNames,
        cityIds,
        cityNames,
        couponsType,
        discountRate,
        fullAmount,
        limitYzzs,
        maxAmount,
        newLimit,
        orderDeliveryType,
        platformCouponName,
        platformCouponShowName,
        userMaxCheckType,
        shopLimit,
        type,
        validDay,
        dailyLimit,
        validBegin,
        validEnd,
      } = params;
      const shopLimitArr = shopLimit
        ? marketingPlatformCoupon.formatShopLimit(JSON.parse(shopLimit))
        : null;
      const newParams = {
        platformCouponBatchId,
        allLimit,
        amount,
        cbdIds,
        cbdNames,
        cityIds,
        cityNames,
        couponsType,
        discountRate,
        fullAmount,
        limitYzzs,
        maxAmount,
        newLimit,
        orderDeliveryType,
        platformCouponName,
        platformCouponShowName,
        userMaxCheckType,
        shopBlackListLimit: params.couponsType !== '0' ? shopLimitArr : null,
        shopLimit: params.couponsType === '0' ? shopLimitArr : null,
        type,
        validDay,
        dailyLimit,
        validBegin,
        validEnd,
      };
      return newParams;
    },
    async setPlatformCoupon(params, history, addEditType) {
      // 由于换新接口，原来参数是下划线要改成驼峰
      const newParams = marketingPlatformCoupon.formatParams(params);
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/upsertPlatformCoupon', {
        type: 'POST',
        params: filterNull({ ...newParams }),
        useJson: true,
      });
      if (data) {
        if (addEditType === 'edit') {
          message.success('修改平台券成功');
        } else {
          message.success('创建平台券成功');
        }
        history.push('/marketing/platform-coupon');
        marketingPlatformCoupon.setState({ subShopData: [] });
      }
    },
    async getLimitShopData(value) {
      marketingPlatformCoupon.setState({
        shopData: [],
        shopDataFetching: true,
      });
      const data = await fetch('/saasmerchant/web/bms/shop/getShopListByName', {
        params: filterNull({
          shopName: value,
        }),
      });
      if (data) {
        const shopData = data.map((d) => ({
          label: d.shopName,
          id: d.shopId,
        }));
        marketingPlatformCoupon.setState({ shopData });
      }
      marketingPlatformCoupon.setState({ shopDataFetching: false });
    },
    clearLimitShopData() {
      marketingPlatformCoupon.setState({ shopData: [] });
    },
    async onSelectShop(shop) {
      if (shop) {
        const data = await fetch('/saasmerchant/web/bms/shop/getSubShopList', {
          type: 'GET',
          params: filterNull({
            shopId: shop.key,
          }),
        });
        if (data) {
          const subShopData = [
            {
              title: '全选',
              value: 'all',
              key: 'all',
              children: data.map((d) => ({
                title: d.shopName,
                key: d.subShopId,
                value: d.subShopId,
              })),
            },
          ];
          marketingPlatformCoupon.setState({ selectedShop: shop.key, subShopData });
        }
      } else {
        marketingPlatformCoupon.setState({ selectedShop: null, subShopData: [] });
      }
    },
    setLimitShopParams(params) {
      marketingPlatformCoupon.setState({ limitShopParams: params });
    },
    setShopNames(params) {
      marketingPlatformCoupon.setState({ shopNames: params });
    },
    setSubShops(params) {
      marketingPlatformCoupon.setState({ subShops: params });
    },
    // 限制门店列表数据转化成表单数据
    formatShopLimitListToForm(shop_limit) {
      if (!shop_limit || shop_limit.length === 0) return [];
      const shops = shop_limit.map((shop) => ({
        key: shop?.shopId?.toString(),
        label: shop.shopName,
      }));
      const newShops = []; // 去重
      shops.forEach((shop) => {
        if (!newShops.find((newshop) => newshop.key === shop.key)) {
          newShops.push(shop);
        }
      });
      const params = {};
      shop_limit.forEach((shop) => {
        if (!params[shop.shopId]) {
          params[shop.shopId] = [];
        }
        if (shop.subShopId) {
          params[shop.shopId].push(shop.subShopId);
        }
      });
      marketingPlatformCoupon.setShopNames(newShops);
      marketingPlatformCoupon.setLimitShopParams(params);
      // 默认选中第一个门店
      marketingPlatformCoupon.setSubShops(params[newShops[0].key]);

      marketingPlatformCoupon.onSelectShop(newShops[0]);
      return newShops;
    },

    // 获取省市信息
    async getCities() {
      const data = await getCityList();
      marketingPlatformCoupon.setState({
        cities: data.map((province) => {
          return {
            title: province.label,
            value: province.value,
            key: province.value,
            children: province.children.map((city) => {
              return {
                title: city.label,
                value: city.value,
                key: city.value,
              };
            }),
          };
        }),
      });
      return data;
    },
    async getBusinessDistrict(value) {
      marketingPlatformCoupon.setState({
        rangeData: [],
        rangeDataFetching: true,
      });
      if (!value) return;
      const data = await fetch(
        '/saasmerchant/fsarea/businessDistrict/getBusinessDistrictIdByName',
        {
          params: {
            businessDistrictName: value,
            cbdStatus: 1, // 0是返回所有状态的商圈，1返回生效商圈，2返回失效商圈，默认为0
          },
        },
      );
      if (data) {
        const rangeData = data.map((d) => ({
          label: d.businessDistrictName,
          id: String(d.businessDistrictId),
        }));
        marketingPlatformCoupon.setState({ rangeData });
      }
      marketingPlatformCoupon.setState({ rangeDataFetching: false });
    },
    clearRangeData() {
      marketingPlatformCoupon.setState({ rangeData: [] });
    },
    setRangeTableData(rangeTableData) {
      marketingPlatformCoupon.setState({ rangeTableData });
    },
    clearLimitData() {
      marketingPlatformCoupon.setState({
        limitShopParams: {}, // 门店
        shopData: [],
        shopNames: [],
        selectedShop: null,
        subShopData: [],
        subShops: [],
        cities: [], // 城市
        rangeData: [], // 商圈
        rangeTableData: [],
        cbd_ids: '', // 商圈id
        cbd_name: '', // 商圈名称
      });
    },
    async getCouponDetailById(batchId) {
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/detail/info', {
        params: {
          batchId,
        },
      });
      return data;
    },
  }),
};

export default model;
